<template>
  <div class="page" v-cloak>
    <!-- <van-nav-bar :border="false" left-arrow fixed title="活动" class="user_service_nav_bar" @click-left="onClickLeft" :z-index="20" :style="'background: #2998FF; color:#FFFFFF;'"></van-nav-bar> -->
    <!-- <van-nav-bar :border="false" fixed title="领取优惠券" class="user_service_nav_bar" :z-index="20" :style="'background: #2998FF; color:#FFFFFF;'"></van-nav-bar> -->

    <div class="hear-img">

    </div>
    <div class="form-block">
      <!-- 输入手机号，调起手机号键盘 -->
      <van-field v-model="phone" type="tel" label="手机号" placeholder="请输入手机号" />
      <van-field v-model="code" center clearable label="短信验证码" placeholder="请输入短信验证码">
        <template #button>
          <van-button v-if="time == 0" size="small" type="primary" color="#3492F6" plain hairline @click="codeClick">获取验证码</van-button>
          <van-button v-if="time > 0" size="small" type="primary" color="#CCCCCC" plain hairline>{{ time }}s</van-button>
        </template>
      </van-field>

      <!-- 按钮 -->
      <van-button class="foot-btn" type="primary" color="#E64D33" block @click="login">立即领取</van-button>
    </div>

  </div>
</template> 

<script>
export default {
  name: "receive-coupons",
  components: {},
  props: {},
  data() {
    return {
      couponId: this.$route.query.couponId, //优惠券ID
      checked: false,
      time: 0,
      currentTime: 60,
      phone: "",
      isPhone: false,
      code: "",
      aa: {},
    };
  },
  watch: {
    phone(newValue, oldValue) {
      if (!/^1[3456789]\d{9}$/.test(newValue)) {
        this.isPhone = false;
      } else {
        this.isPhone = true;
      }
    },
    aa: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {},
  methods: {
    login() {
      var that = this;

      if (!that.couponId) {
        this.$toast.fail("活动已结束！");
      }
      if (!/^1[3456789]\d{9}$/.test(that.phone)) {
        this.$toast.fail("请填写正确的手机号！");
        return;
      }
      if (!that.code) {
        this.$toast.fail("验证码有误，请重新填写！");
        return;
      }
      // if (!that.checked) {
      //   this.$toast.fail("请选择已阅读并同意服务条款！");
      //   return;
      // }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      let data = {
        phone: that.phone,
        code: that.code,
        coupon_id: that.couponId,
      };
      this.$post("/api/activityRecharge", data, data).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 0) {
          this.$toast.clear(); //关闭弹窗
          that.$toast({ message: "领取成功~" });

          that.$router.replace({ name: "index", query: {} });
        } else {
          that.$toast.fail(res.data.message);
        }
      });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    // 条款
    // goClause() {
    //   this.$router.push({
    //     name: "zdyx-clause",
    //     query: {
    //       id: "",
    //     },
    //   });
    // },
    codeClick() {
      var that = this;
      var currentTime = that.currentTime;

      if (!/^1[3456789]\d{9}$/.test(that.phone)) {
        this.$toast.fail("请填写正确的手机号！");
        return;
      }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      let data = {
        type: 7,
        phone: that.phone,
      };
      this.$post("/api/SendCode", data, data).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.$toast.clear(); //关闭弹窗
          this.$toast({
            message: "已发送验证码~",
          });

          that.time = currentTime;
          let interval = setInterval(function () {
            that.time = currentTime - 1;
            currentTime--;
            if (currentTime <= 0) {
              clearInterval(interval);
              that.time = 0;
              that.currentTime = 60;
            }
          }, 1000);
        } else {
          this.$toast.fail(res.data.message);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.user_service_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
.van-cell {
  background-color: #f4f4f4;
  margin-bottom: 10px;
}
</style>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  text-align: left;
  background-color: #df5649;
  background-image: url("../../assets/icon/coupons.png");
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 100% 100%;
  position: relative;

  h3 {
    text-align: left;
    margin-top: 70px;
    padding-left: 30px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 61px;
    color: #2a2e43;
  }

  .form-block::before {
    content: "";
    position: absolute;
    width: 184px;
    height: 32px;
    left: 81px;
    top: 0px;
    z-index: 1;
    // background-color: #555;
    background-image: url("../../assets/icon/coupons2.png");
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: 100% 100%;
    //
  }
  .form-block {
    position: absolute;
    top: 245px;
    left: 15px;
    padding: 52px 20px 20px 20px;
    width: 345px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 10px;
  }

  .foot-btn {
    width: 100%;
    height: 44px;
    border-radius: 5px;
    margin: 30px auto 0;

    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    letter-spacing: 1px;
  }
  .go-page {
    padding: 0 15px;
    text-align: left;
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    letter-spacing: 1px;
  }
}
</style>
